import styled from 'styled-components';
import { ContainerBase } from '../../widgets/layouts';

export const ContainerSmall = styled(ContainerBase)<{ isFullWidth?: boolean }>`
    ${(p) => !p.isFullWidth && 'max-width: 600px'};
`;
